import { PropsWithChildren } from 'react'

interface CellProps extends PropsWithChildren {
  className?: string
}

const Cell = ({ children, className }: CellProps) => (
  <td>
    <div className={className}>{children}</div>
  </td>
)

export default Cell
